// @flow

import * as React from 'react';

import {Button} from '@sail/ui';
import type {TailorComponentExample} from './index';

/* eslint-disable no-alert */

const basic: TailorComponentExample = {
  rendered: <Button type="primary">Hello!</Button>,
  source: `<Button type="primary">Hello!</Button>`,
};

const primary: TailorComponentExample = {
  rendered: (
    <Button type="primary" onPress={() => alert('Button was pressed')}>
      Primary button
    </Button>
  ),
  source: `<Button type="primary" onPress={() => alert('Button was pressed')}>
Primary button
</Button>`,
};

const secondary: TailorComponentExample = {
  rendered: (
    <Button onPress={() => alert('Button was pressed')}>
      Secondary button
    </Button>
  ),
  source: `<Button onPress={() => alert('Button was pressed')}>
Secondary button
</Button>`,
};

const destructive: TailorComponentExample = {
  rendered: (
    <Button type="destructive" onPress={() => alert('Button was pressed')}>
      Destructive button
    </Button>
  ),
  source: `<Button type="destructive" onPress={() => alert('Button was pressed')}>
Destructive button
</Button>`,
};

const sizes: TailorComponentExample = {
  rendered: (
    <>
      <Button size="small">Small button</Button>
      <Button>Medium button</Button>
      <Button size="large">Large button</Button>
    </>
  ),
  source: `<Button size="small">Small button</Button>
<Button>Medium button</Button>
<Button size="large">Large button</Button>`,
};

const disabled = {
  rendered: (
    <>
      <Button type="primary" disabled>
        Primary
      </Button>
      <Button disabled>Secondary</Button>
      <Button type="destructive" disabled>
        Destructive
      </Button>
    </>
  ),
  source: `<Button type="primary" disabled>Hello!</Button>
<Button disabled>Secondary</Button>
<Button type="destructive" disabled>Destructive</Button>`,
};

export const ButtonExamples = {
  basic,
  primary,
  secondary,
  destructive,
  sizes,
  disabled,
};
